import React from 'react'
import PropTypes from 'prop-types'

import BlogPost from '../BlogPost'
import BlogPostPreview from '../BlogPostPreview'

class BlogContent extends React.Component {
  static propTypes = {
    mainPost: PropTypes.object.isRequired,
    otherPosts: PropTypes.array.isRequired,
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps(next) {
    if (next.mainPost !== this.props.mainPost) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { mainPost, otherPosts } = this.props
    return (
      <div className="blog-wrapper">
        <BlogPost
          title={mainPost.fields.title}
          date={mainPost.fields.date}
          src={mainPost.fields.featuredImage.fields.file.url}
          alt={mainPost.fields.featuredImage.fields.title}
          main={mainPost.fields.mainContent}
          town={mainPost.location.town}
          region={mainPost.location.region}
          tags={mainPost.fields.tags}
          isHome={false}
        />
        <aside className="blog-more relative">
          <div className="blog-more__header">
            <h2>Older Posts</h2>
          </div>
          <div className="blog-more__content-wrapper">
            { otherPosts.map((post, i) => (
              i < 4 &&
              <BlogPostPreview
                key={post.sys.id}
                title={post.fields.title}
                slug={post.fields.slug}
                id={post.sys.id}
                date={post.fields.date}
                src={post.fields.featuredImage.fields.file.url}
                town={post.location.town}
                region={post.location.region}
                loaderHidden={true}
              />
            ))}
          </div>
        </aside>
      </div>
    )
  }
}

export default BlogContent



// WEBPACK FOOTER //
// /opt/build/repo/src/components/blog-page/BlogContent.js